import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight, ShieldCheck, Sparkles, Lock, CreditCard, RefreshCcw, Zap } from 'lucide-react';
const EBOOK_MOCKUP = 'https://cdn.magicpatterns.com/uploads/hCxSG2xozuu1vd1XdXi4xU/cover_3.png';
export function FinalCTA() {
  return <Section id="offer" className="bg-[#0a0a0a] py-32" data-id="element-56">
      <div className="glow-line w-full max-w-xs mx-auto mb-16" data-id="element-57" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-58">
        <h2 className="text-4xl md:text-6xl font-black text-white mb-8 leading-tight" data-id="element-59">
          Deja de publicar para el algoritmo.
          <br data-id="element-60" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#14b8a6] to-[#2dd4bf]" data-id="element-61">
            Publica para monetizar.
          </span>
        </h2>

        <p className="text-xl text-gray-400 mb-14 max-w-2xl mx-auto leading-relaxed" data-id="element-62">
          INGRESOS DIGITALES ATÓMICOS te da el sistema, los guiones, los prompts
          y el plan. Lo único que no puede darte es ejecución.
        </p>

        {/* Luxury Pricing Card */}
        <div className="luxury-border max-w-lg mx-auto relative overflow-hidden" data-id="element-63">
          {/* Subtle glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-32 bg-[#14b8a6] blur-[100px] opacity-[0.06]" data-id="element-64" />

          {/* Ebook Mockup */}
          <div className="p-8 pb-0 relative z-10" data-id="element-65">
            <img src={EBOOK_MOCKUP} alt="Ebook Ingresos Digitales Atómicos — Tablet y Móvil" className="w-full max-w-[240px] mx-auto drop-shadow-[0_15px_40px_rgba(20,184,166,0.1)]" data-id="element-66" />
          </div>

          <div className="luxury-divider mx-8 mt-6" data-id="element-67" />

          {/* Pricing */}
          <div className="p-8 md:p-10 relative z-10" data-id="element-68">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-69">
              <Sparkles size={16} className="text-[#14b8a6]" data-id="element-70" />
              <span className="text-[#14b8a6] text-xs font-bold uppercase tracking-[0.2em]" data-id="element-71">
                Oferta de lanzamiento
              </span>
              <Sparkles size={16} className="text-[#14b8a6]" data-id="element-72" />
            </div>

            <div className="text-center mb-8" data-id="element-73">
              <span className="text-gray-500 line-through text-lg" data-id="element-74">
                $47 USD
              </span>
              <div className="text-5xl md:text-6xl font-black text-white mt-2 tracking-tight" data-id="element-75">
                $6.39 USD
              </div>
            </div>

            <Button size="lg" className="w-full text-xl mb-6" onClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart', {
                content_name: 'Ingresos Digitales Atómicos',
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
            }
            window.open('https://www.simplementemejor.com/cart/51696108929304:1', '_blank');
          }} data-id="element-76">
              DESCARGAR AHORA <ArrowRight className="ml-2" data-id="element-77" />
            </Button>

            {/* Trust Badge Row */}
            <div className="flex items-center justify-center gap-2 text-gray-400 text-sm mb-6" data-id="element-78">
              <Lock size={14} className="text-[#14b8a6]/60" data-id="element-79" />
              <span data-id="element-80">Pago 100% seguro con encriptación SSL</span>
            </div>

            <div className="luxury-divider mb-6" data-id="element-81" />

            {/* Trust Guarantees */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-center" data-id="element-82">
              <div className="flex flex-col items-center gap-2 p-3" data-id="element-83">
                <div className="w-9 h-9 rounded-xl bg-[#14b8a6]/10 border border-[#14b8a6]/15 flex items-center justify-center" data-id="element-84">
                  <Zap size={16} className="text-[#14b8a6]" data-id="element-85" />
                </div>
                <div data-id="element-86">
                  <p className="text-white text-xs font-semibold" data-id="element-87">
                    Acceso inmediato
                  </p>
                  <p className="text-gray-500 text-[10px]" data-id="element-88">
                    Descarga al instante
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-center gap-2 p-3" data-id="element-89">
                <div className="w-9 h-9 rounded-xl bg-[#14b8a6]/10 border border-[#14b8a6]/15 flex items-center justify-center" data-id="element-90">
                  <ShieldCheck size={16} className="text-[#14b8a6]" data-id="element-91" />
                </div>
                <div data-id="element-92">
                  <p className="text-white text-xs font-semibold" data-id="element-93">
                    Compra protegida
                  </p>
                  <p className="text-gray-500 text-[10px]" data-id="element-94">
                    Datos 100% seguros
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-center gap-2 p-3" data-id="element-95">
                <div className="w-9 h-9 rounded-xl bg-[#14b8a6]/10 border border-[#14b8a6]/15 flex items-center justify-center" data-id="element-96">
                  <CreditCard size={16} className="text-[#14b8a6]" data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <p className="text-white text-xs font-semibold" data-id="element-99">Pago único</p>
                  <p className="text-gray-500 text-[10px]" data-id="element-100">Sin suscripciones</p>
                </div>
              </div>
            </div>

            {/* Satisfaction note */}
            <div className="mt-6 glass-card p-4 flex items-start gap-3 text-left" data-id="element-101">
              <RefreshCcw size={18} className="text-[#14b8a6] shrink-0 mt-0.5" data-id="element-102" />
              <div data-id="element-103">
                <p className="text-white text-xs font-semibold" data-id="element-104">
                  Garantía de satisfacción
                </p>
                <p className="text-gray-400 text-[11px] leading-relaxed" data-id="element-105">
                  Si en 7 días sientes que no es para ti, te devolvemos el 100%
                  de tu dinero. Sin preguntas.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Extra trust below card */}
        <p className="mt-8 text-gray-500 text-xs max-w-md mx-auto leading-relaxed" data-id="element-106">
          Más de{' '}
          <span className="text-gray-300 font-semibold" data-id="element-107">500+ personas</span> ya
          descargaron el método. Tu información está protegida y nunca será
          compartida con terceros.
        </p>
      </div>
    </Section>;
}